import useMedia from "utils/hooks/useMedia.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { AffiliationTabs } from "features/affiliation/common/types.ts";
import { LanguageNameSpaces } from "@shared/types";

interface useTabToDisplayProps {
  fullName?: boolean;
}

export const useTabToDisplay = ({ fullName }: useTabToDisplayProps) => {
  const isShortTabs = useMedia([`(max-width: 650px)`], [true], false);
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  const tabToDisplay = {
    [AffiliationTabs.OVERVIEW]: t("tabs.overview"),
    [AffiliationTabs.REFERRAL_LINKS]: t("tabs.referral_links"),
    [AffiliationTabs.REFERRED_USERS]: t("tabs.referred_users"),
    [AffiliationTabs.EXISTING_USERS]: t("tabs.existing_users"),
    [AffiliationTabs.EARNINGS]: t("tabs.earnings"),
    [AffiliationTabs.PAYOUTS]: t("tabs.payouts"),
  };

  const mobileTabToDisplay = {
    [AffiliationTabs.OVERVIEW]: t("mobile_tabs.overview"),
    [AffiliationTabs.REFERRAL_LINKS]: t("mobile_tabs.referral_links"),
    [AffiliationTabs.REFERRED_USERS]: t("mobile_tabs.referred_users"),
    [AffiliationTabs.EXISTING_USERS]: t("mobile_tabs.existing_users"),
    [AffiliationTabs.EARNINGS]: t("mobile_tabs.earnings"),
    [AffiliationTabs.PAYOUTS]: t("mobile_tabs.payouts"),
  };

  return isShortTabs && !fullName ? mobileTabToDisplay : tabToDisplay;
};
